var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65499 0.309394L6.46779 4.8748C6.53046 4.97705 6.52446 5.10795 6.45046 5.20369C6.11644 5.63744 5.77776 6.02494 5.49308 6.2835C5.49308 6.2835 5.26507 6.50623 5.12039 6.60262C4.92305 6.75827 4.66504 6.83317 4.41436 6.83317C4.13301 6.83317 3.867 6.75111 3.65432 6.58764C3.61632 6.55052 3.44897 6.40919 3.3123 6.27568C2.46159 5.49676 1.05619 3.4635 0.630167 2.39411C0.561497 2.23846 0.418157 1.82295 0.410156 1.60738C0.410156 1.39962 0.455492 1.19903 0.55483 1.00625C0.691504 0.769191 0.903514 0.583578 1.15486 0.479375C1.32954 0.412294 1.85356 0.308742 1.8689 0.308742C2.24291 0.241661 2.76827 0.191514 3.38164 0.166765C3.49164 0.162206 3.59832 0.217564 3.65499 0.309394Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.16851 0.614525C5.04383 0.413283 5.20318 0.159939 5.44252 0.169708C6.00388 0.193805 6.49857 0.235486 6.86659 0.286285C6.87459 0.2941 7.52729 0.397652 7.74797 0.516835C8.15799 0.72459 8.40867 1.13229 8.40867 1.57059V1.60706C8.40134 1.88971 8.15066 2.49084 8.13532 2.49084C8.00932 2.79368 7.79597 3.189 7.53929 3.61428C7.42329 3.80575 7.13861 3.81031 7.0206 3.61884L5.16851 0.614525Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown2);
export default __webpack_public_path__ + "static/media/Arrow---Down-2.a5c2191e4029e375628c0b1fb3a85550.svg";
export { ForwardRef as ReactComponent };